import axios from "axios";
import { baseUrl } from "../App";

export const fetchUserPlayingHistory = async (token) => {
  const res = await axios.get(`${baseUrl}/api/participantProfile/playing_history/?portal=15`, {
    headers: { Authorization: `Token ${token}` }
  });
  return res.data;
}